import {
  get,
  isArray,
  isObject,
  isString,
  filter as loadashFiler,
  reduce as lodashReduce,
  flatMapDepth,
  flatMap,
  find,
} from 'lodash';
import createUid from '~/utils/createUid';
import { getContacts } from '~/api/contacts';
import { Person } from '~/types/Person';
import { Shareholders } from '~/types/Shareholders';
import { Contacts } from '~/types/Contacts';

export const handleDisablingByCopying = (props: any) => {
  const { selectedContact, name } = props;
  const fieldName = isArray(name) ? name.slice(name.indexOf('data') + 1) : name;
  const fieldNameStringified = isArray(name) ? fieldName?.join(',') : name;
  const selectedContactKeys = Object.entries(selectedContact || {})
    ?.map((item: any) => {
      const [key, value] = item;

      if (isString(value)) {
        return key;
      }
      return Object.keys(value || {}).map((ele) => String([key, ele]));
    })
    ?.flat();
  const missingFieldsData = selectedContact?.salesforceFields;
  const hasCardholderRole = selectedContact?.userRoles?.includes('cardholder');

  return hasCardholderRole && get(selectedContact, fieldName) && fieldNameStringified !== 'role' && hasCardholderRole;
};

export const contactObjCreation = (obj: any, config: any) => {
  const { type, role } = config;
  const userRoles = (type: string, role: string) => {
    if (type === 'DELETE') {
      return obj?.userRoles?.filter((item: any) => item !== role);
    }
    if (type === 'ADD') {
      return obj?.userRoles?.length ? [...new Set([...obj?.userRoles, role])] : [role];
    }
    return obj?.userRoles;
  };
  return {
    contactId: obj?.contactId ?? createUid(),
    matchContactId: obj?.matchContactId ?? null,
    firstName: obj?.firstName ?? undefined,
    lastName: obj?.lastName ?? undefined,
    email: obj?.email ?? undefined,
    dateOfBirth: obj?.dateOfBirth || obj?.dateOfBirth || undefined,
    nationality: obj?.nationality ?? undefined,
    phoneNo: obj?.workPhone ?? obj?.phoneNo,
    mobileNo: obj?.mobile ?? obj?.mobileNo,
    country: obj?.country ?? 'United Arab Emirates',
    passport: obj?.passport ?? {},
    emiratesId: obj?.emiratesId ?? {},
    userRoles: userRoles(type, role),
    salesForceUser: obj?.salesForceUser ?? false,
    salesforceFields: obj?.salesforceFields,
    secondName: obj?.secondName,
  };
};
export const getUpdatedContact = async (record: any, type?: any) => {
  const allContacts = await getContacts();
  const latestContact = allContacts?.reduce((obj: any, item: any) => {
    const itemValue = item?.contacts?.find((ele: any) => ele?.contactId === record?.contactId);
    if (!Object.keys(obj || {})?.length && itemValue) {
      obj = itemValue;
    }
    return obj;
  }, {});
  if (type === 'LATEST') {
    return latestContact;
  }
  return { ...record, userRoles: latestContact?.userRoles };
};

export const getContactDataFromUpdatedList = async (currentContactData: any) => {
  const allContactsUpdatedData = await getContacts();
  const currentContactUpdatedDataArray = flatMapDepth(allContactsUpdatedData, (item) =>
    loadashFiler(item.contacts, { contactId: currentContactData?.data?.contactId }),
  );
  const currentContactDataObj = lodashReduce(currentContactUpdatedDataArray, (result) => result);
  return currentContactDataObj;
};

export const missingFieldsHandler = (obj1: any, obj2: any) => {
  const handleObj = (obj: any) => {
    return Object?.entries(obj || {})
      ?.map(([key, value]: any) => {
        if (!value?.length && isObject(value)) {
          return Object.keys(value || {})?.map((item) => [key, item]);
        }

        return key;
      })
      ?.flat()
      ?.map((item) => String(item));
  };
  const missingFieldsValue = handleObj(obj1)?.filter(function (item) {
    return handleObj(obj2)?.indexOf(item) === -1;
  });
  return missingFieldsValue;
};
export const getUpdatedUsersData = ({ convertedData, newRecord, activeTab }: any) => {
  const reducedData = Object.entries(convertedData || {})?.reduce((acc: any, item: any) => {
    const [key, value] = item;
    const selectedUsersData = value?.map((item: any) => {
      if (item?.contactId === newRecord?.contactId) {
        return { ...item, ...newRecord, uid: item?.uid };
      }
      return item;
    });
    acc = {
      ...acc,
      [key]: selectedUsersData,
    };
    return acc;
  }, {});

  return reducedData;
};

export const getUpdatedInitialUsersData = async ({ existedData }: any) => {
  const allContacts = await getContacts();
  const contactsMapping = allContacts?.map((item: any) => item?.contacts)?.flat();
  const reducedData = Object.entries(existedData || {})?.reduce((acc: any, item: any) => {
    const [key, value] = item;
    const selectedUsersData = value?.map((item: any) => {
      const replacedItem = contactsMapping?.find((ele: any) => ele?.contactId === item?.contactId);
      return { ...item, ...replacedItem };
    });
    acc = {
      ...acc,
      [key]: selectedUsersData,
    };
    return acc;
  }, {});

  return reducedData;
};

export const getUpdatedShareholderData = async ({ existedData }: any) => {
  const allContacts = await getContacts();
  const contactsMapping = allContacts?.map((item: any) => item?.contacts)?.flat();
  const reducedData = Object.entries(existedData || {})?.reduce((acc: any, item: any) => {
    const [key, value] = item;
    const selectedUsersData = isArray(value)
      ? value?.map((item: any) => {
          const replacedItem = contactsMapping?.find((ele: any) => ele?.contactId === item?.data?.contactId);
          return { ...item, data: { ...item?.data, ...replacedItem } };
        })
      : value;
    acc = {
      ...acc,
      [key]: selectedUsersData,
    };
    return acc;
  }, {});

  return reducedData;
};

export const getUpdatedShareholderDataSync = ({ existedData }: any, allContacts = []) => {
  const contactsMapping = allContacts?.map((item: any) => item?.contacts)?.flat();
  const reducedDatacedData = Object.entries(existedData || {})?.reduce((acc: any, item: any) => {
    const [key, value = []] = item;

    const selectedUsersData = isArray(value)
      ? value?.map((item: any) => {
          const replacedItem = contactsMapping?.find((ele: any) => ele?.contactId === item?.data?.contactId);
          return { ...item, data: { ...item?.data, ...replacedItem } };
        })
      : value;
    acc = {
      ...acc,
      [key]: selectedUsersData,
    };
    return acc;
  }, {});

  return reducedDatacedData;
};

export const getUpdatedAuthorizedRepresentativeDataSync = (
  draftData: Person[],
  allContacts: Contacts[],
  sourceOfEditing: string,
) => {
  const contactsMapping = allContacts?.map((item: Contacts) => item.contacts).flat();
  return (draftData || []).map((draftItem: Person) => {
    const contactsData = contactsMapping?.find((ele) => ele?.contactId === draftItem?.contactId);
    return sourceOfEditing === 'authorizedRepresentative'
      ? { ...contactsData, ...draftItem }
      : { ...draftItem, ...contactsData };
  });
};

export const missingFieldsBackupHandler = (data: any, selectedContact: any) => {
  const dataValues: any = Object?.values(data || {})?.flat();
  return dataValues?.find((item: any) => item?.contactId === selectedContact?.contactId)?.missingFields;
};
